import { getTextValue } from '@/lib/helpers/LocalizedText'
import { documentTypes } from '@/config'

import camelcaseKeys from 'camelcase-keys'

import { ServiceRequests } from '@/services/service.requests'

const serviceService = new ServiceRequests()

const state = {
  loading: false,
  configuration: null,
  tosFile: null,
}

const getters = {
  loadingConfiguration: (state) => state.loading,
  skipRegisterGuestTypeIds: (state) => { try { return state.configuration.registrationCardConfiguration.steps.find(step => step.type === 'DOCUMENT_DATA').configuration.skipRegisterGuestTypeIds } catch { return null } },
  editableFields: (state) => { try { return state.configuration.registrationCardConfiguration.steps.find(step => step.type === 'DOCUMENT_DATA').configuration.editableFields } catch { return null } },
  contactDataEnabled: (state) => { try { return state.configuration.registrationCardConfiguration.steps.find(step => step.type === 'CONTACT_DATA').enabled } catch { return false } },
  getDashboardName: (state) => ({ pageName }) => { try { return getTextValue(state.configuration.preconfiguredPages.find(preconfiguredPage => preconfiguredPage.pageName === pageName).title) } catch { return null } },
  getCardAppearance: (state) => state.configuration.cardAppearance,
}

const actions = {
  getConfiguration ({ commit }, { authenticated }) {
    commit('setLoading', true)
    return new Promise((resolve, reject) => {
      serviceService[authenticated ? 'getConfiguration' : 'getServiceConfiguration']()
        .then((configuration) => {
          commit('setConfiguration', camelcaseKeys(configuration, { deep: true }))
          resolve(configuration)
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          commit('setLoading', false)
        })
    })
  },
  getTosFile ({ commit }, { fileId }) {
    return new Promise((resolve, reject) => {
      serviceService.getPublicFile(fileId).then((file) => {
        commit('setTosFile', file)
        resolve(file)
      }).catch((error) => {
        reject(error)
      })
    })
  },
}

const mutations = {
  setConfiguration (state, configuration) {
    if (configuration.registrationCardConfiguration) {
      const documentDataStep = configuration.registrationCardConfiguration.steps.find(step => step.type === 'DOCUMENT_DATA')
      if (documentDataStep) {
        documentTypes.forEach(type => {
          documentDataStep.configuration[type.allowedKey] = documentDataStep.configuration[type.allowedKey]
            ? documentDataStep.configuration[type.allowedKey].map((country) => {
              return country.toLowerCase()
            }) : []
        })
      }
      var index = configuration.registrationCardConfiguration.steps.findIndex(step => step.type === 'DOCUMENT_DATA')
      if (index !== -1) {
        configuration.registrationCardConfiguration.steps[index] = documentDataStep
      }
    }
    state.configuration = configuration
  },
  setLogo (state, { logoPath, image }) {
    state.configuration.customization.logo[logoPath] = image
  },
  setTosFile (state, tosFile) {
    state.tosFile = tosFile
  },
  setLoading (state, value) {
    state.loading = value
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
